import { render, staticRenderFns } from "./HelloWorld4.vue?vue&type=template&id=eef675f4&scoped=true&"
import script from "./HelloWorld4.vue?vue&type=script&lang=js&"
export * from "./HelloWorld4.vue?vue&type=script&lang=js&"
import style0 from "./HelloWorld4.vue?vue&type=style&index=0&id=eef675f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef675f4",
  null
  
)

export default component.exports